import { Component } from '@angular/core';
import { WalletPaymentMethodType } from '@platform-frontend/marketplace';

@Component({
  selector: 'yat-add-payment-method',
  templateUrl: './add-payment-method.component.html',
  styleUrls: ['./add-payment-method.component.scss']
})
export class AddPaymentMethodComponent {
  toWalletPaymentMethodType(activeWalletData: WalletPaymentMethodType): WalletPaymentMethodType {
    return activeWalletData;
  }
}
